import workspaceQuery from '../../queries/supplier/PurchaseCreditWorkspaceQuery.graphql';
import instanceQuery from '../../queries/supplier/PurchaseCreditQuery.graphql';
import defaultQuery from '../../queries/supplier/PurchaseCreditDefault.graphql';
import mutationQuery from '../../mutations/supplier/PurchaseCreditMutation.graphql';
import temporaryMutationQuery from '../../mutations/supplier/SavePurchaseCreditTempMutation.graphql';
import aggregateQuery from '../../queries/supplier/PurchaseCreditAggregateQuery.graphql';
import fragment from '../../fragments/supplier/PurchaseCreditFragment.graphql';

import { formActionsForPermissions } from '../../../actions/supplier/PurchaseCreditAction';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseCredit: EntityType = {
  type: 'PurchaseCredit',
  title: 'Purchase Credit',
  formTitle: 'Purchase Credit',
  formUrl: '/Suppliers/Credit/Details/',
  workspaceUrl: '/Suppliers/Credit/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SUPPLIER_CREDITS',
  actions: formActionsForPermissions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'CREDITED'],
    },
  ],
};

export default PurchaseCredit;
